




























































import {Component, Prop, Vue} from "vue-property-decorator";
import ImageUploader from "@/components/UI/ImageUploader.vue";
import ItemsStore from "@/_common/api/store/modules/ItemsStore";
import {Util} from "@/_global/utils";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import NameInputs from "@/components/UI/NameInputs.vue";

@Component({
    components: {
        ImageUploader,
        NameInputs,
    }
})
export default class MainItem extends Vue {
    @Prop() private itemId!: number;

    get deliousItem(): Delious.ItemBase {
        return DeliousItemsStore.itemById[this.itemId] || {}
    }

    get cmsItem(): CMS.Item {
        return ItemsStore.itemById[this.itemId] || {}
    }

    private onImageChange(url: string) {
        const edited: CMS.Item = Util.deepCopy(this.cmsItem);
        edited.image_url = url;
        ItemsStore.localEdit(edited);
    }

    private onImageDelete() {
        const edited: CMS.Item = Util.deepCopy(this.cmsItem);
        edited.image_url = "";
        ItemsStore.localEdit(edited);
    }

    private onChangeName(languageCode: string, name: string): void {
        const edited: CMS.Item = Util.deepCopy(this.cmsItem);
        edited.names[languageCode] = name;
        ItemsStore.localEdit(edited);
    }
}
